import axios from "axios";
import { decryptEnv } from "../utils/decryptEnv";
import localforage from "localforage";

export async function loadConfig(token) {
  const env = {
    REACT_APP_TEAMS_URL: process.env.REACT_APP_TEAMS_URL,
    REACT_APP_MONDAY_URL: process.env.REACT_APP_MONDAY_URL,
    NANGO_API_URL: process.env.REACT_APP_NANGO_API_URL,
    SERVER: process.env.REACT_APP_SERVER,
    API_URL: process.env.REACT_APP_API_URL,
    Chat_API: process.env.REACT_APP_CHAT_API,
    Iframe_URL: process.env.REACT_APP_IFRAME_URL,
    PANDORA_API: process.env.REACT_APP_PANDORA_API,
    ACCOUNT_LEVEL: process.env.REACT_APP_ACCOUNT_LEVEL,
    AGENCY_LEVEL: process.env.REACT_APP_AGENCY_LEVEL,
    DROPBOX_CLIENT_ID: process.env.REACT_APP_DROPBOX_CLIENT_ID,
    GCP_CLIENT_ID: process.env.REACT_APP_GCP_CLIENT_ID,
    GCP_API_KEY: process.env.REACT_APP_GCP_API_KEY,
    PANDORA_AUTH: process.env.REACT_APP_PANDORA_AUTH,
    Chat_Auth: process.env.REACT_APP_CHAT_AUTH,
    API_ENV: process.env.REACT_APP_API_ENV,
    GDriveURL: process.env.REACT_APP_GDRIVEURL,
    FACEBOOK_AUTH: process.env.REACT_APP_FACEBOOK_AUTH,
    ONBOARDING_URL: process.env.REACT_APP_ONBOARDING_URL,
    SUPER_ADMIN: process.env.REACT_APP_SUPER_ADMIN,
    GHL: {
      CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID,
      CLIENT_SECRET: process.env.REACT_APP_GHL_CLIENT_SECRET,
      ACCOUNT_CLIENT_ID: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_ID,
      ACCOUNT_CLIENT_SECRET: process.env.REACT_APP_GHL_ACCOUNT_CLIENT_SECRET,
      Location_CLIENT_ID: process.env.REACT_APP_GHL_LOCATION_CLIENT_ID,
      Location_CLIENT_SECRET: process.env.REACT_APP_GHL_LOCATION_CLIENT_SECRET,
      Location_SCOPE: process.env.REACT_APP_GHL_LOCATION_SCOPE,
      SCOPE: process.env.REACT_APP_GHL_SCOPE,
      ACCOUNT_SCOPE: process.env.REACT_APP_GHL_ACCOUNT_SCOPE,
      REDIRECT: {
        ACCOUNT: process.env.REACT_APP_GHL_REDIRECT_ACCOUNT,
        LOCAITON: process.env.REACT_APP_GHL_REDIRECT_LOCATION,
        AGENCY: process.env.REACT_APP_GHL_REDIRECT_AGENCY,
      },
    },
    STRIPE: {
      PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
      CLIENT_ID: process.env.REACT_APP_STRIPE_CLIENT_ID,
    },
    NANGO_API_HOST: process.env.REACT_APP_NANGO_API_HOST,
    NANGO_CONNECT_UI_HOST: process.env.REACT_APP_NANGO_CONNECT_UI_HOST,
  };

  // The backend now requires auth on this endpoint, so a call with no
  // token (the pre-login boot call in src/index.js) would always 401 -
  // skip the network round-trip entirely and keep the build-time env
  // defaults until the post-login refresh in AppShell.jsx calls this again
  // with a real token.
  if (!token) {
    return env;
  }

  const user = await localforage.getItem("user");

  try {
    const res = await axios.get(
      `${env.API_URL}/v1/frontend?type=social-calendar&userId=${user?._id || "user"}`,
      { headers: { "x-auth-token": `Bearer ${token}` } }
    );

    const { envs } = decryptEnv(res.data.data, user?._id || 'user');

    env.SERVER = envs.REACT_APP_SERVER;
    env.Chat_API = envs.REACT_APP_CHAT_API;
    env.PANDORA_API = envs.REACT_APP_PANDORA_API;
    env.ACCOUNT_LEVEL = envs.REACT_APP_ACCOUNT_LEVEL;
    env.AGENCY_LEVEL = envs.REACT_APP_AGENCY_LEVEL;
    env.DROPBOX_CLIENT_ID = envs.REACT_APP_DROPBOX_CLIENT_ID;
    env.GCP_CLIENT_ID = envs.REACT_APP_GCP_CLIENT_ID;
    env.GCP_API_KEY = envs.REACT_APP_GCP_API_KEY;
    env.PANDORA_AUTH = envs.REACT_APP_PANDORA_AUTH;
    env.Chat_Auth = envs.REACT_APP_CHAT_AUTH;
    env.API_ENV = envs.REACT_APP_API_ENV;
    env.GDriveURL = envs.REACT_APP_GDRIVEURL;
    env.FACEBOOK_AUTH = envs.REACT_APP_FACEBOOK_AUTH;
    env.ONBOARDING_URL = envs.REACT_APP_ONBOARDING_URL;
    env.SUPER_ADMIN = envs.REACT_APP_SUPER_ADMIN;
    env.GHL.ACCOUNT_CLIENT_ID = envs.REACT_APP_GHL_ACCOUNT_CLIENT_ID;
    env.GHL.ACCOUNT_CLIENT_SECRET = envs.REACT_APP_GHL_ACCOUNT_CLIENT_SECRET;
    env.GHL.Location_CLIENT_ID = envs.REACT_APP_GHL_LOCATION_CLIENT_ID;
    env.GHL.Location_CLIENT_SECRET = envs.REACT_APP_GHL_LOCATION_CLIENT_SECRET;
    env.GHL.Location_SCOPE = envs.REACT_APP_GHL_LOCATION_SCOPE;
    env.GHL.SCOPE = envs.REACT_APP_GHL_SCOPE;
    env.GHL.ACCOUNT_SCOPE = envs.REACT_APP_GHL_ACCOUNT_SCOPE;
    env.GHL.REDIRECT.ACCOUNT = envs.REACT_APP_GHL_REDIRECT_ACCOUNT;
    env.GHL.REDIRECT.LOCAITON = envs.REACT_APP_GHL_REDIRECT_LOCATION;
    env.GHL.REDIRECT.AGENCY = envs.REACT_APP_GHL_REDIRECT_AGENCY;
    env.STRIPE.PUBLIC_KEY = envs.REACT_APP_STRIPE_PUBLIC_KEY;
    env.STRIPE.CLIENT_ID = envs.REACT_APP_STRIPE_CLIENT_ID;
    env.GHL.CLIENT_ID = envs.REACT_APP_GHL_CLIENT_ID;
    env.GHL.CLIENT_SECRET = envs.REACT_APP_GHL_CLIENT_SECRET;
    env.REACT_APP_MONDAY_URL = envs.REACT_APP_MONDAY_URL;
    env.REACT_APP_TEAMS_URL = envs.REACT_APP_TEAMS_URL;
    env.NANGO_API_HOST = envs.REACT_APP_NANGO_API_HOST;
    env.NANGO_CONNECT_UI_HOST = envs.REACT_APP_NANGO_CONNECT_UI_HOST;
    return env
  } catch (e) {
    console.error("Failed to load remote env:", e);
    return env;
  }
}
